import config from 'config';

export const defaultPreferences = {
    assetProperties: Object.keys(config.assets.columnOptions),
};
